import { createContext, useContext } from "react";

const EVENTS_BASE_PATH_DEFAULT = "/events";

export const EventsBasePathContext = createContext<string>(EVENTS_BASE_PATH_DEFAULT);

export function useEventsBasePath(): string {
  return useContext(EventsBasePathContext);
}
